import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import Button from 'flarum/common/components/Button';
export default function addFrontPage() {
  extend(DiscussionControls, 'moderationControls', function (items, discussion) {
    if (!discussion.front()) return;
    let isFront = discussion.frontpage();
    items.add('frontpage', m(Button, {
      icon: "fas fa-home",
      onclick: () => {
        isFront = !isFront;
        discussion.save({
          frontpage: isFront
        });
      }
    }, app.translator.trans(discussion.frontpage() ? 'core.forum.post_controls.pull_from_front_button' : 'core.forum.post_controls.push_to_front_button')));
  });
}
flarum.reg.add('fof-frontpage', 'forum/extenders/addFrontPage', addFrontPage);